var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4ZM13.8272 5.44983C17.7243 9.06036 17.7243 14.9396 13.8272 18.5502C13.5233 18.8317 13.0488 18.8136 12.7673 18.5097C12.4858 18.2059 12.5039 17.7313 12.8078 17.4498C16.0641 14.4329 16.0641 9.56706 12.8078 6.55017C12.5039 6.26866 12.4858 5.79413 12.7673 5.49028C13.0488 5.18643 13.5234 5.16832 13.8272 5.44983ZM11.6687 7.44985C14.3735 9.95581 14.3735 14.0442 11.6687 16.5502C11.3649 16.8317 10.8903 16.8136 10.6088 16.5097C10.3273 16.2059 10.3454 15.7314 10.6493 15.4498C12.7134 13.5375 12.7134 10.4625 10.6493 8.55019C10.3454 8.26868 10.3273 7.79415 10.6088 7.4903C10.8903 7.18645 11.3649 7.16834 11.6687 7.44985ZM9.50972 9.44986C11.0223 10.8513 11.0223 13.1488 9.50972 14.5502C9.20587 14.8317 8.73134 14.8136 8.44983 14.5098C8.16832 14.2059 8.18643 13.7314 8.49028 13.4499C9.36214 12.6421 9.36214 11.358 8.49028 10.5502C8.18643 10.2687 8.16832 9.79417 8.44983 9.49032C8.73134 9.18646 9.20587 9.16835 9.50972 9.44986Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfc);
export default __webpack_public_path__ + "static/media/nfc.0a81fabe4fb3b587a8ecb4efe505270b.svg";
export { ForwardRef as ReactComponent };